import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { GoalsIcon } from '@atlaskit/temp-nav-app-icons/goals';

import { Products } from '../../constants';
import type { GlobalShortcutsItem } from '../../types';

import { messages } from './messages';

export default function goals(fallbackUrl: () => string): GlobalShortcutsItem {
	return {
		icon: <GoalsIcon size="20" />,
		label: <FormattedMessage {...messages.label} />,
		apsKey: Products.ATLAS_GOALS,
		fallbackUrl,
	};
}
